module.exports = __webpack_public_path__ + "media/crashing_waves.baf5b583.mp4";